<template>
  <div
    class="base-hint"
    @mouseenter="isHintPopupVisible = true"
    @mouseleave="isHintPopupVisible = false"
    @touch="isHintPopupVisible = !isHintPopupVisible"
  >
    i
    <span
      :class="[
        'base-hint-popup',
        { 'base-hint-popup_visible': isHintPopupVisible }
      ]"
    >
      {{ hintText }}
    </span>
  </div>
</template>

<script>
  // WARNING: need 'position: relative;' parent!

  export default {
    name: 'BaseHint',
    props: {
      hintText: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        isHintPopupVisible: false
      }
    }
  }
</script>

<style lang="scss">
  .base-hint {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    min-width: 24px;
    max-width: 24px;
    height: 24px;
    margin-left: 10px;
    font-size: 13px;
    cursor: help;
    background: $c-gray;
    border: none;
    border-radius: 50%;
    outline: none;

    &-popup {
      position: absolute;
      top: 0;
      left: 10%;
      z-index: 99999;
      display: block;
      width: 290px;
      padding: 12px 20px;
      font-size: 12px;
      color: $c-gray-dark;
      text-align: left;
      visibility: hidden;
      background: $c-gray;
      opacity: 0;
      transition: opacity 0.3s, visibility 0.3s;
      transform: translate(0, -110%);

      &_visible {
        visibility: visible;
        opacity: 1;
      }

      @include mobile {
        left: 0;
      }
    }
  }
</style>
